import { IAction } from '@zaibot/fsa';
import { IEmailMessage } from '../../types';

interface IState {
    visible: boolean;
    items: IEmailMessage[];
}

const emptyState: IState =  { 
    visible: false,  
    items: [],
}; 

export const selector = (state: any) => state.batchdelete as IState;

export const reducer = (state = emptyState, action: IAction) => {

  return state;

};



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/emailarchive/emails/reducer.tsx